import { createBrowserRouter } from "react-router-dom";
import LoginPage from "../auth/LoginPage";
import MiddleRouterBoundary from "../common/components/Layout/MiddleRouterBoundary";
import RootBoundary from "../common/components/Layout/RootBoundary";
import ThemeLayout from "../theme/layout/ThemeLayout";
import UserPage from "../user";
import { appRoute } from "./appRouteConfig";
import App from "App";
import HomePage from "../modules/HomePage";
import Redirect from "@pagesChannel/Redirect";

const appRouteConfig = appRoute.reduce((current, next) => {
  const currentRoute = current ?? [];
  return currentRoute.concat(
    next.listRoute.map((v) => {
      return {
        ...v,
        element: <MiddleRouterBoundary>{v.element}</MiddleRouterBoundary>,
      };
    })
  );
}, []);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ThemeLayout outlet={<RootBoundary />} />,
    children: [
      ...appRouteConfig,
      {
        path: "/user",
        element: <UserPage />,
      },
      {
        path: "/",
        element: <HomePage />,
      },
    ],
  },
  { path: "/login", element: <LoginPage /> },
  { path: "/redirect", element: <Redirect /> },
]);
